<template>
  <div class="over">
    <div class="header">
      <top-component ref="topRef" :datalogintype="1" ></top-component>
      <div class="header_sousuo">
        <div style="width:100%;display:flex;margin-bottom: 10px; align-items: center; margin-top: 20px;">
          <div style="width:30%; display: flex; align-items: end; margin-bottom: 8px;">
            <img style="width:58px;display:block; margin-right: 15px;"  src="../../assets/images/shuxiang.png" alt="">
            <div style="font-size: 40px;">云田购</div>
          </div>
          <div style="width:70%;margin-top:1%">
            <div class="searchcontainer">
              <input type="text" v-model="searchTerm" placeholder="请输入搜索内容">
              <div
                style="width: 100px;height:41px;text-align:center;line-height:41px;background-color:#CA1A1B;color:#fff;font-size:14px;cursor: pointer;"
                @click="toSearchListCopy(searchTerm)">
                查询</div>

            </div>
            <div style="width:92%;display:flex;justify-content: space-between;">
              <div style="color: #969696;margin-right: 15px;height: 20px;overflow: hidden;font-size:13px;cursor: pointer;
                width:70%;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;
                ">
                热搜:
                <span v-for="(item,index) in overlistbanner.hotwords" :key="index"
                  @click="toSearchListCopy(item)">&nbsp; {{item}} </span>
              </div>
              <div
                style="color: #969696;margin-right: 15px;height: 20px;overflow: hidden;font-size:13px;cursor: pointer;"
                @click="toSearchList()">
                高级查询</div>
            </div>

          </div>
        </div>
        <div style="display:flex;width:100%;margin-top:30px">
          <div
            style="width:24%;height:40px;background-color:#CA1A1B;font-size:15px;font-weight: 500;line-height: 40px;color: #fff; text-indent: 0.5em;font-weight: 700;margin-top:10px">
            全部分类
          </div>
          <div
            style="display:flex;justify-content: space-between;width:40%;line-height:40px;margin-left:15px;height:40px;margin-top:10px;">
            <div v-for="(item,index) in newList" :key="index" @click="TESEtuijianTo(item.typeCode, item.typeName)" class="tuijian">
              {{item.typeName}}
            </div>
          </div>

        </div>

      </div>

    </div>

    <div class="shenzi">
      <div style="display:flex;height:405px;position: relative;">
        <div class="oneclass" style="display:flex" @mouseover="jinru" @mouseout="yichu">
          <div class="oneclass_kuai">
            <div class="oneclass_xuanz">
              <div :class="oneclassState==item.name?'oneclass_classon':'oneclass_class'    "
                @click="xuanzefenlei(item.name)" v-for="(item,index) in fenleiList" :key="index">
                <span style="display:block">{{item.name}}</span>
                <i class="el-icon-caret-bottom" style="padding-top:13px" v-show="oneclassState==item.name"></i>
              </div>
            </div>
            <el-skeleton :rows="8" animated v-if="GuJiaPing" />
            <div style="width:100%;max-height:200px;cursor: pointer;" v-else>
              <div :class="zibiaoqianList.name==item.name?'oneclass_yijion':'oneclass_yiji'    "
                v-for="(item,index) in classList" :key="index" @mouseover="shangxiahuadong(item)"
                @click="ChinesClick(item,oneclassState)">
                <div style="display:flex">
                  <div style="font-size:13px">{{item.classifyTypeCode}}&nbsp;</div>
                  <div class="typenames">
                    {{item.name}}</div>
                </div>
                <div style="display:flex;margin-top:10px;">
                  <div style="display:flex;margin-right:10px;font-size:12px;margin-top:1px"
                    v-for="(O,I) in item.cHildrenCopy" :key="I">
                    [{{O.classifyTypeName}}]
                  </div>
                </div>

              </div>
            </div>
          </div>
          <div style="width:76%;height:411px;background-color:#fbfbfb;position: absolute;z-index: 100000;left: 24%;-webkit-box-shadow: 2px 0 5px rgba(0,0,0,.1);box-shadow: 2px 0 5px rgba(0,0,0,.1);-webkit-transition: top .25s ease;transition: top .25s ease;"
            v-show="twoclassstate">
            <div class="fudong_text">
              {{zibiaoqianList.name}}
              <i class="el-icon-caret-bottom"></i>
            </div>
            <div class="fudong_textneirong">
              <div class="textneirong" v-for="(item,index) in zibiaoqianList.children" :key="index"
                @click="erjitiaozhuan(item)">
                {{item.classifyTypeName}}
              </div>
            </div>
          </div>
        </div>

        <div class="shenzi_left">
          <el-skeleton :rows="11" animated v-if="overlistbanner.banner==undefined" />
          <el-carousel height="410px" class="banner-box" :interval="3000" v-else>
            <el-carousel-item v-for="(item,index) in overlistbanner.banner" :key="index">
              <img :src="item.bannerurl" @click="TESEtuijianTo(item.pkid, item.shudanmingcheng,'ad'+ item.pkid )"
                style="cursor: pointer;" />
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>
      <el-skeleton :rows="11" animated v-if="overlistbanner.classList==undefined" />
      <div class="zdtj" v-for="(item,index) in overlistbanner.types" :key="index">
        <div style="display:flex;    justify-content: space-between;">
          <div class="zdtj_next">
            <img src="https://cxstar.com/Content/bglibimg/ic-HotDmd.png" alt="">
            {{item.shudanmingcheng}}
          </div>
          <div class="sjemzo_right_new_overon" @click="TESEtuijianTo(item.pkid,item.shudanmingcheng)">
            查看全部>
          </div>
        </div>
        <div class="zdtj_overlist">
          <div class="zdtj_overlist_list" v-for="(O,I) in item.goods" :key="I"
            @click="BookTuiClickRowid(O.goodsId,item.shudanerpid)">
            <img
              style="width: 100px;height: 140px;cursor: pointer;margin-top: 20px;border-radius: 5px;margin-bottom: 15px;"
              :src="O.imageUrl" alt="">
            <div style="line-height: 20px;
              font-size: 14px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              font-weight: bold;
              width: 80%;
              padding: 0px 10%;
              margin-bottom: 5px;"
              :title="O.title">
              {{O.title}}</div>
            <div class="box_list"
              style="font-size: 12px;max-height: 20px;overflow: hidden;line-height: 20px;text-overflow: ellipsis;white-space: nowrap;">
              {{O.author}}</div>
            <div class="box_list">{{O.publisher}}</div>
            <div class="box_list">{{O.publishTime}}</div>
          </div>
        </div>

      </div>

      <el-skeleton :rows="11" animated v-if="overlistbanner.types==undefined" />
      <div class="zxsj" v-else>
        <div class="zxsj_top">
          <div class="zdtj_next">
            最新上架
          </div>
          <i class="icon iconfont iconarrowleft" style="line-height: 50px;" @click="preList('ulWrap')"></i>
          <div class="levelClass">
            <div :class="index==leveListindex?'levelClass_liston':'levelClass_list' "
              v-for="(item,index) in overlistbanner.classList" :key='index' @mouseover='jingguo(item,index)'
              @click="ChinesClick(item,'中图法分类')">
              {{item.classifyTypeName}}
            </div>
          </div>
          <i class="icon iconfont iconarrowright" style="line-height: 50px;" @click="nextList('ulWrap')"></i>
        </div>
        <div class="zxsj_list">
          <div class="zxsj_list_over" v-for="(item,index) in zxList" :key="index"
            @click="BookTuiClickRowid(item.goodsId)">
            <img style="height: 156px;width: 116px;border-radius: 5px;margin: 0 20px;margin-top:20px"
              :src="item.imageUrl" alt="">
            <div class="zxsj_list_over_right">
              <div class="class1" :title="item.title">{{item.title}}</div>
              <div class="class2">{{item.author}}</div>
              <div class="zxsj_text">{{item.publisher}}</div>
              <div class="zxsj_text">{{item.publishTime}}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="ceshi">
        <div class="zxsj_top" v-if="overlistbanner.groupname">
          <div class="zdtj_next">
            {{overlistbanner.groupname[0].k}} 
          </div>
          <i class="icon iconfont iconarrowleft" style="line-height: 50px;" @click="preListCopy('ulWrap')"></i>
          <div class="levelClassCopy">
            <div :class="I==leveListindexCopy?'levelClass_liston':'levelClass_list' "
              v-for="(O,I) in overlistbanner.groupname[0].v" :key='I' @mouseover='rexiaojinru(O,I)'
              @click="TESEtuijianTo(O.pkid, O.shudanmingcheng)">
              {{O.shudanmingcheng}}
            </div>
          </div>
          <i class="icon iconfont iconarrowright" style="line-height: 50px;" @click="nextListCopy('ulWrap')"></i>
        </div>
        <div class="zxsj_list">
          <div class="zxsj_list_over" v-for="(items,indexs) in zxListCopy" :key="indexs"
            @click="BookTuiClickRowid(items.goodsId)">
            <img style="height: 156px;width: 116px;border-radius: 5px;margin: 0 20px;margin-top:20px"
              :src="items.imageUrl" alt="">
            <div class="zxsj_list_over_right">
              <div class="class1">{{items.title}}</div>
              <div class="class2">{{items.author}}</div>
              <div class="zxsj_text">{{items.publisher}}</div>
              <div class="zxsj_text">{{items.publishTime}}</div>
            </div>

          </div>

        </div>

      </div>

      <div class="ceshi">
        <div class="zxsj_top" v-if="overlistbanner.groupname">
          <div class="zdtj_next">
            {{overlistbanner.groupname[1].k}}
          </div>
          <i class="icon iconfont iconarrowleft" style="line-height: 50px;" @click="preListCopyCopy('ulWrap')"></i>
          <div class="levelClassCopyCopy">
            <div :class="I==leveListindexCopyCopy?'levelClass_liston':'levelClass_list' "
              v-for="(O,I) in overlistbanner.groupname[1].v" :key='I' @mouseover='rexiaojinruCopy(O,I)'
              @click="TESEtuijianTo(O.pkid, O.shudanmingcheng)">
              {{O.shudanmingcheng}}
            </div>
          </div>
          <i class="icon iconfont iconarrowright" style="line-height: 50px;" @click="nextListCopyCopy('ulWrap')"></i>
        </div>
        <div class="zxsj_list">
          <div class="zxsj_list_over" v-for="(items,indexs) in zxListCopyCopy" :key="indexs"
            @click="BookTuiClickRowid(items.goodsId)">
            <img style="height: 156px;width: 116px;border-radius: 5px;margin: 0 20px;margin-top:20px"
              :src="items.imageUrl" alt="">
            <div class="zxsj_list_over_right">
              <div class="class1">{{items.title}}</div>
              <div class="class2">{{items.author}}</div>
              <div class="zxsj_text">{{items.publisher}}</div>
              <div class="zxsj_text">{{items.publishTime}}</div>
            </div>

          </div>

        </div>

      </div>



      <!-- <div class="zxsj" >
        <div class="zxsj_top">
          <div class="zdtj_next">
            测试
          </div>
          <i class="icon iconfont iconarrowleft" style="line-height: 50px;" @click="preList('ulWrap')"></i>
          <div class="levelClass">
            <div :class="index==leveListindex?'levelClass_liston':'levelClass_list' "
              v-for="(item,index) in overlistbanner.classList" :key='index' @mouseover='jingguo(item,index)'
              @click="ChinesClick(item,'中图法分类')">
              {{item.classifyTypeName}}
            </div>
          </div>
          <i class="icon iconfont iconarrowright" style="line-height: 50px;" @click="nextList('ulWrap')"></i>
          <div class="sjemzo_right_new_overon" @click="TESEtuijianTo(item.shudanerpid,item.shudanmingcheng)">
            查看全部>
          </div> 
        </div>
        <div class="zdtj_overlist">
          <div class="zdtj_overlist_list" v-for="(item,index) in zxList" :key="index"
            @click="BookTuiClickRowid(item.goodsId)">
              <img
              style="width: 100px;height: 140px;cursor: pointer;margin-top: 20px;border-radius: 5px;margin-bottom: 15px;"
              :src="item.imageUrl" alt="">
            <div
              style="line-height: 20px;font-size: 14px;max-height: 40px;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;font-weight: bold;width: 80%;white-space: inherit;padding: 0 10%;margin-bottom: 5px;">
              {{item.title}}</div>
            <div class="box_list"
              style="font-size: 12px;max-height: 20px;overflow: hidden;line-height: 20px;text-overflow: ellipsis;white-space: nowrap;">
              {{item.author}}</div>
            <div class="box_list">{{item.publisher}}</div>
            <div class="box_list">{{item.publishTime}}</div>
          </div>
        </div>
      </div> -->
    </div>
    <!-- <div>  
      <el-dialog
        style="z-index: 100000;"
        :visible.sync="erweima"
        width="20%"
        :show-footer="false"
        class="centered-dialog">
        <div style="display:flex ; justify-content: center; align-items: center; flex-direction: column; width: 100%; height: 100%;">
        <img alt="example" style="width: 225px; height: 225px;" src="../../assets/images/gh_9466731f8652_258 (1).jpg" />
        <div style="font-size:18px; margin-top: 15px;font-family: serif;">微信扫描二维码</div>
        </div>
      </el-dialog>
      <el-dialog
        style="z-index: 100000;"
        :visible.sync="contactusphone"
        width="20%"
        :show-footer="false"
        class="centered-dialog">
        <div style="display:flex ; justify-content: center; align-items: center; flex-direction: column; width: 100%; height: 100%;">
        <div style="font-size: 20px;">027-51850968</div>
        <div style="font-size:18px; margin-top: 15px;">客服热线</div>
        </div>
      </el-dialog>
    </div>
    <div class="sidenavigationbar">
      <div class="sidenavigationbaritem"  @click="showerweima()" >
          <img style="width:50px" src="../../assets/images/erwe2.png" alt="">
            <span style="display: block;font-family:'Alimama'">移动端选书</span>
      </div>
      <div class="sidenavigationbaritem"  @click="contactus()" >
        <img style="width:50px" src="../../assets/images/5e9f2b1b0da09ac3b3961378284ef2d4.png" alt="">
          <span style="display: block;font-family:'Alimama'">联系我们</span>
    </div>
      <div class="sidenavigationbaritem"   @click="ProblemReport()" >
        <img style="width:50px; height: 50px;" title="问题反馈" src="../../assets/images/fankui.jpg" alt="">
        <span style="display: block;font-family:'Alimama';">问题反馈</span>
    </div>
    </div> -->
    <bottom-component label="线上图采会"></bottom-component>

  </div>
</template>
<script>
  import { listclassifyTypes, listpopularTypes, searchlist, actionall } from '@/api/img'
  import TopComponent from '../Components/TopComponentcopy.vue'
  import BottomComponent from '../Components/HomeBottomComponent.vue'

  import Cookies from 'js-cookie'
  export default {
    data() {
      return {
        // erweima: false,  
        // contactusphone:false,
        GuJiaPing: true,
        Index: '中图法分类',
        searchTerm: '',
        oneclassState: '中图法分类',
        twoclassstate: false,
        newList: [
          { typeName: '精品大码洋', typeCode: '37' },
          { typeName: '建筑科学', typeCode: '41' },
          { typeName: '经济金融', typeCode: '36' },
          { typeName: '桃李寸心', typeCode: '39' },
          { typeName: '党建思政', typeCode: '34' },
        ],
        leveList: [
          { name: '经济' },
          { name: '经济' },
          { name: '经济' },
          { name: '经济' },
          { name: '经济' },
          { name: '经济' },
          { name: '经济' },
          { name: '经济' },
          { name: '经济' },
          { name: '经济12321321' },
        ],
        leveListindex: '0',
        leveListindexCopy: '0',
        leveListindexCopyCopy: '0',
        zxListCopy: [],
        zxListCopyCopy: [],
        logintype:Cookies.get('logintype'),
        zxList: [],
        fenleiList: [
          { name: '中图法分类' },
          { name: '学科分类' },
          { name: '大众分类' },
        ],
        classList: [],
        loading: null,
        zibiaoqianList: [],
        overlistbanner: []
      }
    },
    components: {
      TopComponent,
      BottomComponent
    },
    created() {
      this.how()
      this.zhongtufa()
    },
    mounted(){ 
      this.mysource1()
    },

    methods: {
      mysource1(){
            Cookies.set('logintype', 1)
        },
      // showerweima(file){
      //       this.erweima = !this.erweima
      //   }, 
      // contactus(){
      //   this.contactusphone = !this.contactusphone
      // },
      async how() {
        let data = {}
        let res = await actionall(data)
        if (res.code == 200) {
          this.overlistbanner = res.data
          this.zxList = res.data.classList[0].goods
          this.zxListCopy = res.data.groupname[0].v[0].goods
          this.zxListCopyCopy = res.data.groupname[1].v[1].goods
        }

      },



      jingguo(item, value) {
        this.leveListindex = value
        this.zxList = item.goods

      },




      rexiaojinru(item, value) {
        this.leveListindexCopy = value
        this.zxListCopy = item.goods

      },
      rexiaojinruCopy(item, value) {
        this.leveListindexCopyCopy = value
        this.zxListCopyCopy = item.goods
      },




      openFullScreen2() {
        this.loading = this.$loading({
          target: "body",
          spinner: "el-icon-loading",
          text: "加载中...",
          background: "rgba(255, 255, 255, 0.5)"
        });
      },

      xuanzefenlei(value) {
        this.GuJiaPing = true
        this.oneclassState = value
        if (value == '中图法分类') {
          this.zhongtufa()
        } else if (value == '学科分类') {
          this.zhongtufatwo()
        } else if (value == '大众分类') {
          this.zhongtufathree()

        }
      },
      async zhongtufa() {
        // this.openFullScreen2()
        let data = {
          classifyLevel: 1,
          gid: '',
          all: '100',
          timestamp: 1709618279386,
          signature: '6f2405679d271130fb8a28fdcc79dd20',
        }
        let res = await listclassifyTypes(data)
        if (res.code == 200) {
          this.classList = res.data
          this.classList.map((item) => {
            item.name = item.classifyTypeName
          })
          this.GuJiaPing = false
          // this.loading.close();

        }

      },
      async zhongtufatwo() {
        let data = {
          classifyLevel: 1,
          gid: '',
          all: '100',
          timestamp: 1709618279386,
          signature: '6f2405679d271130fb8a28fdcc79dd20',
        }
        let res = await searchlist(data)
        if (res.code == 200) {
          this.classList = res.data
          this.classList.map((item) => {
            item.name = item.subjectName
            item.children.map((o) => {
              o.classifyTypeName = o.subjectName
            })
            item.cHildrenCopy = item.children.slice(0, 2)
          })
          this.GuJiaPing = false
        }

      },
      async zhongtufathree() {
        // this.openFullScreen2()

        let data = {
          classifyLevel: 1,
          gid: '',
          all: '100',
          timestamp: 1709618279386,
          signature: '6f2405679d271130fb8a28fdcc79dd20',
        }
        let res = await listpopularTypes(data)
        if (res.code == 200) {
          this.classList = res.data
          this.classList.map((item) => {
            item.name = item.typeName
            item.children.map((o) => {
              o.classifyTypeName = o.typeName
            })
          })
          // this.loading.close();

          this.GuJiaPing = false

        }

      },


      shangxiahuadong(item) {
        this.zibiaoqianList = item

        this.twoclassstate = true
      },
      yichu() {
        this.twoclassstate = false
        // this.zibiaoqianList= []

      },
      jinru() {
        this.twoclassstate = true

      },
      BookTuiClickRowid(id, eventId) {
        if(this.$route.params.baseid && !Cookies.get('token') ){
          this.$router.push({ name: "Login", params: { baseid: this.$route.params.baseid } });
        }else{
        if (Cookies.get('token')) {
          //添加埋点
          let doId = +localStorage.getItem('doId') + 1,
            params = {
              goodsId: id
            };
          localStorage.setItem('doId', doId);
          //新页面打开书目详情
          const { href } = this.$router.resolve({
            name: 'BookDetail',
            params: { goodsId: id }
          });
          window.open(href, "_blank");
        } else {
          this.$router.push({ name: 'Login' });
        }
      }
      },
      // 特色专区 （图采会专栏、类目）
      TESEtuijianTo(activityTag, name, eventId) {
        if(this.$route.params.baseid && !Cookies.get('token') ){
          this.$router.push({ name: "Login", params: { baseid: this.$route.params.baseid } });
        }else{
        if (Cookies.get('token')) {
          let params = {
            gid: '0',
            TitleName: name,
            publicType: '', // 大众分类
            cnIbraryType: '', // 中图分类
            subjectId: '', // 学科类别
            activityTag: activityTag, // 1精品大码洋/2畅销书/3医学/4抗疫图书/5少儿专区/6推荐书单/7工具书
            // activityTag: '', // 经典珍藏/重磅推荐/乐活趣览
            goodsType: 1,
            eventId: eventId
          };
          if(this.logintype ==0){
            const { href } = this.$router.resolve({
            name: 'LookPublishingPagesType',
            query: { obj: JSON.stringify(params) }
          });
          window.open(href, "_blank");
          }else{
            const { href } = this.$router.resolve({
            name: 'LookPublishingPagesTypecopy',
            query: { obj: JSON.stringify(params) }
          });
          window.open(href, "_blank");
          }
         
        } else {
          this.$router.push({ name: 'Login' });
        }
      }
      },
      // 中图分类
      ChinesClick(item, index) {
        if (index == '中图法分类') {
          this.ztf(item)
        } else if (index == '学科分类') {
          this.xueke(item)
        } else if (index == '大众分类') {
          this.AllClick(item)
        }
      },

      ztf(item) {
        if(this.$route.params.baseid && !Cookies.get('token') ){
          this.$router.push({ name: "Login", params: { baseid: this.$route.params.baseid } });
        }else{
        let params = {
          gid: '0',
          zttitle: item.classifyTypeName,
          publicType: '', // 大众分类
          cnIbraryType: item.classifyTypeCode, // 中图分类
          subjectId: '', // 学科类别
          activityTag: '', // 1精品大码洋/2畅销书/3医学/4抗疫图书/5少儿专区/6推荐书单/7工具书
          // activityTag: '', // 经典珍藏/重磅推荐/乐活趣览
          goodsType: 1,
        };
        if(this.logintype ==0){
          const router = this.$router.resolve({
          path: '/LookPublishingPagesType',
          query: {
            obj: JSON.stringify(params),
          }
        })
        window.open(router.href)
        }else{
          const router = this.$router.resolve({
          path: '/LookPublishingPagesTypecopy',
          query: {
            obj: JSON.stringify(params),
          }
        })
        window.open(router.href)
        }
       
      }
      },
      xueke(item) {
        if(this.$route.params.baseid && !Cookies.get('token') ){
          this.$router.push({ name: "Login", params: { baseid: this.$route.params.baseid } });
        }else{
        let params = {
          gid: '0',
          xuekeTitle: item.subjectName,
          publicType: '', // 大众分类
          cnIbraryType: '', // 中图分类
          subjectId: item.subjectCode, // 学科类别
          goodsType: 1
        };
        if (this.$route.query.hasOwnProperty('activitytag')) {
          params.activityTag = this.$route.query.activitytag; //10118        三新现货库存
        } else {
          params.activityTag = '';
        }
        if(this.logintype ==0){
          const router = this.$router.resolve({
          path: '/LookPublishingPagesType',
          query: {
            obj: JSON.stringify(params),
          }
        })
        window.open(router.href)
        }else{
          const router = this.$router.resolve({
          path: '/LookPublishingPagesTypecopy',
          query: {
            obj: JSON.stringify(params),
          }
        })
        window.open(router.href)
        }
        

      }

      },
      AllClick(item) {
         if(this.$route.params.baseid && !Cookies.get('token') ){
          this.$router.push({ name: "Login", params: { baseid: this.$route.params.baseid } });
        }else{
          let params = {
          gid: '0',
          title: item.typeName,
          publicType: item.typeCode, // 大众分类
          cnIbraryType: '', // 中图分类
          subjectId: '', // 学科类别
          activityTag: '', // 1精品大码洋/2畅销书/3医学/4抗疫图书/5少儿专区/6推荐书单/7工具书
          goodsType: 1
        };
        if(this.logintype ==0){
          const router = this.$router.resolve({
          path: '/LookPublishingPagesType',
          query: {
            obj: JSON.stringify(params),
          }
        })
        window.open(router.href)
        }else{
          const router = this.$router.resolve({
          path: '/LookPublishingPagesTypecopy',
          query: {
            obj: JSON.stringify(params),
          }
        })
        window.open(router.href)
        }
       
        }
      },

      erjitiaozhuan(item) {
        if (this.oneclassState == '中图法分类') {
          this.ztf(item)
        } else if (this.oneclassState == '学科分类') {
          this.xueke(item)
        } else if (this.oneclassState == '大众分类') {
          this.AllClick(item)

        }
      },
      guding(item) {
        this.AllClick(item)

      },
      toSearchList() {
        if(this.$route.params.baseid && !Cookies.get('token') ){
          this.$router.push({ name: "Login", params: { baseid: this.$route.params.baseid } });
        }else{
        if (Cookies.get("token")) {
          if(this.logintype ==0){
            const router = this.$router.resolve({
            path: "LookPublishingPagesType",
            query: { obj: JSON.stringify({ modeChange: 2, gid: 0 }) },
          });
          window.open(router.href)
          }else{
            const router = this.$router.resolve({
            path: "LookPublishingPagesTypecopy",
            query: { obj: JSON.stringify({ modeChange: 2, gid: 0 }) },
          });
          window.open(router.href)
          }
         
        } else {
          this.$router.push({ name: "Login" });

        }
      }
      },
      toSearchListCopy(time) {
        if(this.$route.params.baseid && !Cookies.get('token') ){
          this.$router.push({ name: "Login", params: { baseid: this.$route.params.baseid } });
        }else{
        if (Cookies.get("token")) {
          if(this.logintype ==0){
            const router = this.$router.resolve({
            path: "LookPublishingPagesType",
            query: { obj: JSON.stringify({ sousuoName: time }) },
          });
          window.open(router.href)
          }else{
            const router = this.$router.resolve({
            path: "LookPublishingPagesTypecopy",
            query: { obj: JSON.stringify({ sousuoName: time }) },
          });
          window.open(router.href)
          }
         
        } else {
          this.$router.push({ name: "Login" });
        }
      }
      },

       //客户问题反馈
      //  ProblemReport() {
      //       if (Cookies.get("token")) {
      //           const { href } = this.$router.resolve({
      //             name: 'ProblemReport',
      //          });
      //       window.open(href, '_blank');
      //       } else {
      //           this.$router.push({ name: "Login" });
      //       }
      //   },




      nextList() {
        var container = document.querySelector('.levelClass');
        container.scrollLeft += 500; // 设置滚动距离
      },
      preList() {
        var container = document.querySelector('.levelClass');
        container.scrollLeft -= 500; // 设置负值滚动距离，实现往左滚动
      },
      nextListCopy() {
        var container = document.querySelector('.levelClassCopy');
        container.scrollLeft += 500; // 设置滚动距离
      },
      preListCopy() {
        var container = document.querySelector('.levelClassCopy');
        container.scrollLeft -= 500; // 设置负值滚动距离，实现往左滚动
      }, nextListCopyCopy() {
        var container = document.querySelector('.levelClassCopyCopy');
        container.scrollLeft += 500; // 设置滚动距离
      },
      preListCopyCopy() {
        var container = document.querySelector('.levelClassCopyCopy');
        container.scrollLeft -= 500; // 设置负值滚动距离，实现往左滚动
      },

    }
  }
</script>



<style scoped lang='scss'>
  .header {
    width: 100%;
    background-color: #fff;
    border-bottom: 3px solid #ca1a1b;
  }

  .header_sousuo {
    width: 1224px;
    margin: 0 auto;
  }

  .shenzi {
    width: 1224px;
    margin: 0 auto;
  }

  .shenzi_left {
    width: 76%;
    min-height: 160px;
    box-sizing: border-box;
    // height: 100px;
    // border: 1px solid #e4e4e4;
  }

  .sjemzo_right {
    width: 21%;
    height: 400px;
    box-sizing: border-box;
    background-color: #ffffff;
    border-radius: 20px;
    margin-left: 2%;
    padding: 20px;
  }

  .el-carousel__item h3 {
    color: #475669;
    font-size: 14px;
    opacity: 0.75;
    line-height: 150px;
    margin: 0;
  }

  .sjemzo_right_new {
    display: flex;
    justify-content: space-between;
  }

  .sjemzo_right_new_over {
    color: #8e7054;
    font-size: 13px;
    height: 35px;
    line-height: 35px;
    position: relative;
    left: -10px;
    font-weight: normal;
    cursor: pointer;
  }

  .sjemzo_right_new_overon {
    color: #8e7054;
    font-size: 13px;
    height: 50px;
    line-height: 50px;
    position: relative;
    font-weight: normal;
    cursor: pointer;
  }

  .sjemzo_right_new_qun {
    color: #343434;
    float: left;
    font-size: 18px;
    font-weight: bold;
    line-height: 30px;
    height: 35px;
  }

  .sjemzo_right_xinwen {
    width: 100%;
    height: 85%;
  }

  .sjemzo_right_xinwen_url {
    width: 100%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    margin-top: 10px;
    font-size: 13px;
  }

  .zdtj {
    width: 100%;
    margin-top: 40px;
  }

  .zdtj_next {
    font-family: '思源黑体';
    /* text-indent: 1.9em; */
    font-size: 20px;
    font-weight: 800;
    height: 50px;
    line-height: 50px;
  }

  .levelClass {
    width: 88%;
    overflow: hidden;
    display: -webkit-box;
    margin-top: 10px;
    // align-items: center; /* 垂直居中 */
    // justify-content: space-around;

    //   overflow-x: auto;
  }

  .levelClassCopy {
    width: 88%;
    overflow: hidden;
    display: -webkit-box;
    margin-top: 10px;
  }

  .levelClassCopyCopy {
    width: 88%;
    overflow: hidden;
    display: -webkit-box;
    margin-top: 10px;
  }

  .levelClass_list {
    margin-left: 10px;
    display: block;
    cursor: pointer;
    text-align: center;
    line-height: 35px;
    height: 35px;
    color: #5c5052;
    background: white;
    border-radius: 5px;
    padding: 0px 18px;
    font-size: 12px;
  }

  .levelClass_liston {
    margin-left: 10px;

    display: block;
    cursor: pointer;
    text-align: center;
    line-height: 35px;
    height: 35px;
    color: #fff;
    background: #ca1a1b;
    border-radius: 5px;
    padding: 0px 18px;
    font-size: 12px;
  }

  .zdtj_overlist {
    width: 100%;
    height: 305px;
    display: flex;
    justify-content: space-between;
    // display: -webkit-box;
  }

  .zdtj_overlist_list {
  width: 190px;
  height: 302px;
  background: white;
  border-radius: 5px;
  text-align: center;
  color: #666666;
  transition: transform 0.2s, box-shadow 0.2s; /* 添加过渡效果 */
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1); /* 添加阴影效果 */
}

.zdtj_overlist_list:hover {
  transform: translateY(-3px); /* 鼠标进入时上移5像素 */
  box-shadow: 0px 5px 15px rgba(0, 0, 0, 0.2); /* 鼠标进入时增加阴影 */
}

  .zxsj {
    width: 100%;
    margin-top: 40px;
  }

  .zxsj_top {
    display: flex;
    justify-content: space-between;
  }

  .zxsj_list {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
  }

  .zxsj_list_over {
  width: 24%;
  height: 196px;
  background: white;
  border-radius: 5px;
  margin-top: 10px;
  display: flex;
  cursor: pointer;
  transition: transform 0.2s, box-shadow 0.2s; /* 添加过渡效果 */
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1); /* 添加阴影效果 */
}

.zxsj_list_over:hover {
  transform: translateY(-3px); /* 鼠标进入时上移5像素 */
  box-shadow: 0px 5px 15px rgba(0, 0, 0, 0.2); /* 鼠标进入时增加阴影 */
}

  .zxsj_list_over_right {
    margin-top: 50px;
    width: 133px;

    .class1 {
      width: 100%;
    font-size: 14px;
    margin-bottom: 5px;
    color: #825d59;
    font-weight: 800;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    }

    .class2 {
      color: #666666;
      font-size: 12px;
      width: 100%;
      white-space: initial;
      float: left;
      text-align: left;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      margin-bottom: 5px;
    }

    .zxsj_text {
      color: #666666;
      font-size: 12px;
      width: 100%;
      white-space: initial;
      float: left;
      text-align: left;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      margin-bottom: 5px;
    }
  }

  .box_list {
    font-size: 12px;
    max-height: 20px;
    overflow: hidden;
    line-height: 20px;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .el-carousel__item:nth-child(2n) {
    background-color: #99a9bf;
  }

  .el-carousel__item:nth-child(2n + 1) {
    background-color: #d3dce6;
  }

  .oneclass {
    width: 24%;
    height: 100%;
    background-color: #fff;
    padding-bottom: 6px;
    // padding-left: 10px;
    // padding-right: 10px;
    // width: calc(24% - 30px);
  }

  .oneclass_kuai {
    width: 100%;
    height: 100%;
    overflow-y: auto;
  }

  .oneclass_xuanz {
    display: flex;
    position: -webkit-sticky;
    /* 兼容性处理，适用于iOS Safari */
    position: sticky;
    top: 0;
    /* 元素吸顶时距离顶部的距离 */
    z-index: 1000;
    /* 可选，控制元素在吸顶时的堆叠顺序 */
    /* 其他样式，根据您的需求自行添加 */
  }

  .oneclass_class {
    cursor: pointer;
    width: 34%;
    height: 40px;
    background-color: #fff;
    line-height: 40px;
    font-size: 14px;
    text-align: center;
    color: #333;
    display: flex;
    justify-content: center;
  }

  .oneclass_classon {
    cursor: pointer;
    width: 34%;
    height: 40px;
    background-color: #fff;
    line-height: 40px;
    font-size: 14px;
    text-align: center;
    color: #ca1a1b;
    display: flex;
    justify-content: center;
  }

  .oneclass_kuai::-webkit-scrollbar {
    display: none;
  }

  .fudong_text {
    font-size: 17px;
    font-weight: 800;
    color: #333;
    padding: 10px;
  }

  .fudong_textneirong {
    display: flex;
    flex-wrap: wrap;
    padding:0 10px;
  }

  .textneirong {
    cursor: pointer;
    padding: 10px;
    font-size: 12px;
    background-color: #fff0f0;
    margin-right: 10px;
    margin-top: 10px;
  }

  .textneirong:hover {
    // background-color: #ffffff;
    text-decoration: underline;
    font-weight: bold;
    color: #CA1A1B;
  }

  .oneclass_yiji {
    font-size: 13px;
    width: 100%;
    padding: 5px 0px 5px 8px;
    height:28px;
    line-height:28px;
    white-space: nowrap; //不换行
    overflow: hidden; //超出部分隐藏
    text-overflow: ellipsis; //文本溢出显示省略号
    // border-bottom: 1px solid #e4e4e4;
  }

  .oneclass_yijion {
    font-size: 13px;
    width: 100%;
    background-color: #fff0f0;
    padding: 5px 0px 5px 8px;
    height:28px;
    line-height:28px;
    white-space: nowrap; //不换行
    overflow: hidden; //超出部分隐藏
    text-overflow: ellipsis; //文本溢出显示省略号
    // border-bottom: 1px solid #e4e4e4;
  }

  .searchcontainer {
    width: 90%;
    /* 设置搜索框容器的宽度 */
    border: 2px solid #ca1a1b;
    display: flex;
    border-top-left-radius: 5px;
    border-bottom-left-radius: 5px;
  }

  .searchcontainer input {
    border: none;
    padding: 10px;
    width: 87%;
    // border: 2px solid red;
    // border-radius: 6px;
    font-size: 14px;

    border-top-left-radius: 10px;
    border-bottom-left-radius: 10px;
    outline: none;
  }

  .banner-box {
    img {
      // width: 1310px;
      height: 410px;
      border-radius: 4px;
    }
  }

  .tuijian {
    cursor: pointer;
    font-size: 14px;
    font-weight: 800;
  }

  .tuijian:hover {
    color: red;
    font-weight: 800;
  }

  .ceshi {
    margin-top: 40px;
  }

  .typenames {
    font-size: 13px;
    width: 93%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .typenames:hover {
    color: #CA1A1B;
  }
  .sidenavigationbar{
        background-color:#fff;
        position: fixed;
        top: 36%; 
        right: 0px; 
        justify-content: center;
        width: 90px;
        /* height: 360px; */
    }
    .sidenavigationbaritem{
        display: flex; 
        align-items: center;
        flex-direction: column; 
        justify-content: center;
        border-top: 1px solid #dcdcdc ;
        border-left: 1px solid #dcdcdc ;
        border-bottom: 1px solid #dcdcdc ;
        border-right: 1px solid #ffe6e6;
        cursor: pointer;
        width: 100%;
        height: 80px;
        font-size: 14px;

    }
</style>


// WEBPACK FOOTER //
// src/views/Xtch/Xindex.vue